import GenericViewOffline from '../GenericViewOffline';

export default class lang_changed extends GenericViewOffline {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'lang_changed'), data);
        this.auto_destroy = true;
    }
}
